import React, { ReactNode, useEffect, useState } from 'react';

import { fetchTenantUserProfile } from './ProfileFetcher';
import { TenantAuthContext } from './TenantAuthContext';
import { TenantUserProfile } from './types/TenantUserProfile';

export const TenantAuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [profile, setProfile] = useState<TenantUserProfile | undefined>();

  useEffect(() => {
    fetchTenantUserProfile(setProfile);
  }, []);

  return (
    <TenantAuthContext.Provider value={{ profile, setProfile }}>
      {children}
    </TenantAuthContext.Provider>
  );
};
